// These are ECMAScript modules, so TS gives an error due to the node module resolution - but it works at runtime, so we'll just ignore it.
// Typescript v5 has a "bundler" option that will solve this, but we can't upgrade because react-scripts only works with v4.
import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  gql,
  // @ts-expect-error
} from "@apollo/client";
// @ts-expect-error
import { setContext } from "@apollo/client/link/context";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import { getEnvironment } from "@sunrun/sales-experience-shared";
import { getAuthToken } from "utils/authUtils";

const storefrontAPIEndpoint = (() => {
  switch (getEnvironment()) {
    case "production":
      return "https://cffkquzgdvat7o3d6wjihmdaui.appsync-api.us-west-2.amazonaws.com/graphql";
    case "relcert":
      return "https://sl3yopgr2vc3bpwp6ilw47y7xe.appsync-api.us-west-2.amazonaws.com/graphql";
    case "staging":
    default:
      return "https://ujryydofazbhnkvpryhpxj4jsy.appsync-api.us-west-2.amazonaws.com/graphql";
  }
})();

const asyncAuthLink = setContext((request, { headers }) =>
  getAuthToken().then((token) => ({
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  }))
);

const httpLink = createHttpLink({
  uri: storefrontAPIEndpoint,
});

const graphqlLink = createSubscriptionHandshakeLink(
  {
    url: storefrontAPIEndpoint,
    region: "us-west-2",
    auth: {
      type: "AMAZON_COGNITO_USER_POOLS",
      jwtToken: getAuthToken,
    },
  },
  asyncAuthLink.concat(httpLink)
);

const storeFront = new ApolloClient({
  cache: new InMemoryCache(),
  link: graphqlLink,
});

export { storeFront, getAuthToken, gql };
